import { Injectable } from "@angular/core";
import { TipoDocumentacao } from '@tivic-team/manager-ts/dist/grl/entities/tipo-documentacao.entity';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environmentv3 } from 'src/environments/environmentv3';
import { ApiController } from "../api-controller.interface";

@Injectable()
export class TipoDocumentacaoController implements ApiController<TipoDocumentacao>{

    constructor() {}

    find(filters ? : IFilter): Promise <TipoDocumentacao[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/tiposdocumentacao',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new Array<TipoDocumentacao> ())
        );
        return request.call();
    }
    
    get(id: number): Promise <TipoDocumentacao> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/tiposdocumentacao/:cdTipoDocumentacao',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdTipoDocumento: id
                    }),
                }),
            }),
            new HttpResponse(new TipoDocumentacao())
        );
        return request.call();
    }
    
    create(entity: TipoDocumentacao): Promise <TipoDocumentacao> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'grl/tiposdocumentacao',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new TipoDocumentacao()
            )
        );
        return request.call();
    }
    
    update(entity: TipoDocumentacao): Promise <TipoDocumentacao> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'grl/tiposdocumentacao/:cdTipoDocumentacao',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdTipoDocumento: entity.cdTipoDocumentacao
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new TipoDocumentacao()
            )
        );
        return request.call();
    }
    
    async getAll():Promise<Array<TipoDocumentacao>>{
        let quark = new Quark(
            new HttpGet({
                url:new Url({
                    id: 'grl/tiposdocumentacao',
                    environment: environmentv3
                }),
            }),
            new HttpResponse(
                new Array<TipoDocumentacao>()
            )
        );
        return await quark.call();
    }
}
